import ActivationConfirmationScreen from 'features/rewards/SelfFundedOffers/ActivationConfirmationScreen';
import React from 'react';

export default function Page() {
  return <ActivationConfirmationScreen />;
}
